"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var uuid = require("uuid");
var sjcl = require("sjcl");
var utils_1 = require("./utils");
var EncryptionService_1 = require("../services/EncryptionService");
var aws_workdocs_web_client_common_1 = require("@amzn/aws-workdocs-web-client-common");
var ConnectionPersistenceService_1 = require("../services/ConnectionPersistenceService");
exports.WORKDOCS_COMPANION_REQUEST_TIMEOUT_IN_MILLI_SEC = 35000;
exports.WORKDOCS_COMPANION_REQUEST_TIMEOUT_ERROR = 'timeout';
exports.WS_CONNECT_TIMEOUT_IN_MILLI_SEC = 2000;
var WebSocketChannel = (function () {
    function WebSocketChannel(companionConfig, logger, metricService) {
        this.clientType = 'WS';
        this.companionConfig = companionConfig;
        this.logger = logger;
        this.metricService = metricService;
    }
    WebSocketChannel.prototype.wasConnectedByQuickHandshake = function () {
        return this.lastSucceededHandshakeMethod === 'QUICK';
    };
    WebSocketChannel.prototype.getLastSucceededHandshakeMethod = function () {
        return this.lastSucceededHandshakeMethod;
    };
    WebSocketChannel.prototype.getCompanionVersion = function () {
        return this.companionVersion;
    };
    WebSocketChannel.prototype.isConnectionOpen = function (webSocket) {
        return webSocket.readyState === 1;
    };
    WebSocketChannel.prototype.connect = function (config) {
        var _this = this;
        if (!!this.pendingConnectPromise) {
            return this.pendingConnectPromise;
        }
        if (config.handshakeMethods.length < 1) {
            throw Error('There need to be at least one handshake method for making connection');
        }
        this.pendingConnectPromise = (function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a, handshakeErrorReasons, i, method, error_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(config.forcePortScan || !this.webSocket)) return [3, 2];
                        _a = this;
                        return [4, this.setWebSocket()];
                    case 1:
                        _a.webSocket = _b.sent();
                        _b.label = 2;
                    case 2:
                        handshakeErrorReasons = '';
                        i = 0;
                        _b.label = 3;
                    case 3:
                        if (!(i < config.handshakeMethods.length)) return [3, 12];
                        method = config.handshakeMethods[i];
                        _b.label = 4;
                    case 4:
                        _b.trys.push([4, 10, , 11]);
                        if (!(method === 'COOKIE')) return [3, 6];
                        return [4, this.cookieHandshake()];
                    case 5:
                        _b.sent();
                        this.metricService.newCounterMetric('ws_cookie_handshake_succeeded');
                        return [3, 12];
                    case 6:
                        if (!(method === 'QUICK')) return [3, 8];
                        return [4, this.quickHandshake()];
                    case 7:
                        _b.sent();
                        this.metricService.newCounterMetric('ws_quick_handshake_succeeded');
                        return [3, 12];
                    case 8:
                        if (method === 'CLIPBOARD') {
                            throw Error('Not implemented');
                        }
                        _b.label = 9;
                    case 9: return [3, 11];
                    case 10:
                        error_1 = _b.sent();
                        handshakeErrorReasons = handshakeErrorReasons.concat(" " + method + ": " + error_1.message);
                        switch (method) {
                            case 'COOKIE':
                                this.metricService.newCounterMetric('ws_cookie_handshake_failed');
                                break;
                            case 'QUICK':
                                this.metricService.newCounterMetric('ws_quick_handshake_failed');
                                break;
                            default:
                                break;
                        }
                        if (i === config.handshakeMethods.length - 1) {
                            throw Error('[WS] connect failed because:' + handshakeErrorReasons);
                        }
                        return [3, 11];
                    case 11:
                        i++;
                        return [3, 3];
                    case 12: return [4, this.setConfiguration()];
                    case 13:
                        _b.sent();
                        return [2];
                }
            });
        }); })();
        this.pendingConnectPromise.then(function () {
            _this.pendingConnectPromise = null;
        }, function () {
            _this.pendingConnectPromise = null;
        });
        return this.pendingConnectPromise;
    };
    WebSocketChannel.prototype.sendRequest = function (request) {
        var _this = this;
        var secureRequest = utils_1.isSecureOperation(request);
        return new Promise(function (resolve, reject) {
            var sendRequest = function () {
                var timeoutId = null;
                var requestID = utils_1.generateNewRequestID();
                var onErrorHandler = function (event) {
                    _this.logger.error('An error occurred while waiting response from companion');
                    _this.webSocket.close();
                };
                var onCloseHandler = function (event) {
                    var _a;
                    var errorMsg = 'WebSocket connection is closed unexpectedly while waiting for response from companion (event code: ' + ((_a = event) === null || _a === void 0 ? void 0 : _a.code) + ')';
                    _this.logger.error('REQUEST_ERROR_WHILE_WAITING: ' + errorMsg);
                    reject(new Error(errorMsg));
                };
                var onMessageCallback = function (message) {
                    var result;
                    try {
                        try {
                            result = JSON.parse(message.data);
                        }
                        catch (error) {
                            var connectionInfo = ConnectionPersistenceService_1.getConnectionInfo(_this.companionConfig.userID);
                            result = JSON.parse(EncryptionService_1.decrypt(message.data, connectionInfo.cryptoKey));
                        }
                    }
                    catch (error) {
                        _this.logger.error('[WEBSOCKET CHANNEL] Cannot resolve companion response: ' + message.data, error);
                    }
                    if (timeoutId && (result.RequestID === requestID || !secureRequest)) {
                        clearTimeout(timeoutId);
                        timeoutId = null;
                        _this.webSocket.removeEventListener('message', onMessageCallback);
                        if (utils_1.isExceptionalResponse(result)) {
                            _this.metricService.newCounterMetric('WorkDocs_Companion_Request_Sent_Count');
                            _this.logger.error('[WEBSOCKET CHANNEL] Receive error response for action: ' + request.Operation + ': ' + result.ExceptionMessage);
                        }
                        _this.webSocket.removeEventListener('error', onErrorHandler);
                        _this.webSocket.removeEventListener('close', onCloseHandler);
                        resolve(result);
                    }
                };
                if (_this.isConnectionOpen(_this.webSocket)) {
                    var inputMsg = JSON.stringify(tslib_1.__assign(tslib_1.__assign({}, request), { RequestID: requestID }));
                    if (secureRequest) {
                        inputMsg = EncryptionService_1.encrypt(inputMsg, ConnectionPersistenceService_1.getConnectionInfo(_this.companionConfig.userID).cryptoKey);
                    }
                    _this.webSocket.addEventListener('message', onMessageCallback);
                    _this.webSocket.addEventListener('error', onErrorHandler);
                    _this.webSocket.addEventListener('close', onCloseHandler);
                    _this.webSocket.send(inputMsg);
                    timeoutId = window.setTimeout(function () {
                        _this.webSocket.removeEventListener('message', onMessageCallback);
                        timeoutId = null;
                        throw new Error(exports.WORKDOCS_COMPANION_REQUEST_TIMEOUT_ERROR);
                    }, exports.WORKDOCS_COMPANION_REQUEST_TIMEOUT_IN_MILLI_SEC);
                }
                else {
                    throw new Error('Cannot send request because websocket connection is closed');
                }
            };
            if (_this.pendingConnectPromise && !utils_1.isRequestPartOfConnectProcess(request)) {
                _this.pendingConnectPromise.then(function () {
                    _this.sendRequest(request).then(resolve, reject);
                }, reject);
            }
            else {
                if (!_this.webSocket) {
                    throw new Error('Cannot send request because there is no websocket client');
                }
                else {
                    sendRequest();
                }
            }
        });
    };
    WebSocketChannel.prototype.setConfiguration = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var setConfigurationRequest;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setConfigurationRequest = {
                            Operation: 'SetConfiguration',
                            Parameters: this.companionConfig,
                        };
                        return [4, this.sendRequest(setConfigurationRequest)];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    WebSocketChannel.prototype.setWebSocket = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var POSSIBLE_PORTS, i, port, _a, error_2;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        POSSIBLE_PORTS = ['21111', '61165', '51493', '8405', '18664', '3314', '31596', '41756', '37375', '18839'];
                        i = 0;
                        _b.label = 1;
                    case 1:
                        if (!(i < POSSIBLE_PORTS.length)) return [3, 6];
                        port = POSSIBLE_PORTS[i];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        this.logger.debug("Trying to connect on port " + port);
                        _a = this;
                        return [4, this.newConnection("ws://localhost:" + port + "/workdocs", exports.WS_CONNECT_TIMEOUT_IN_MILLI_SEC)];
                    case 3:
                        _a.webSocket = _b.sent();
                        return [2, this.webSocket];
                    case 4:
                        error_2 = _b.sent();
                        if (error_2.message.indexOf('1006: ') === -1) {
                            this.logger.error("Error occurred in resolvePortsAndConnect() " + error_2.message + " and stack is " + error_2.stack);
                        }
                        if (i === POSSIBLE_PORTS.length - 1) {
                            throw new Error('Could not establish ws connection to any port');
                        }
                        return [3, 5];
                    case 5:
                        i++;
                        return [3, 1];
                    case 6: throw new Error('Error at the end of the resolvePortsAndConnect()');
                }
            });
        });
    };
    WebSocketChannel.prototype.newConnection = function (url, timeout) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var socket = new WebSocket(url);
            socket.addEventListener('open', function () {
                clearTimeoutInternal();
                resolve(socket);
            });
            socket.addEventListener('error', function (errorEvent) {
                clearTimeoutInternal();
            });
            socket.addEventListener('close', function (event) {
                clearTimeoutInternal();
                reject(new Error(event.code + ': Connection closed for ' + url + ' because: ' + event.reason));
            });
            var timeoutId = setTimeout(function () {
                reject(new Error('Connection timedout to URL ' + url));
                try {
                    socket.close();
                }
                catch (e) {
                    _this.logger.error("Error occured while closing the Socket in timeout scenario " + e.message + " and " + e.stack);
                }
            }, timeout);
            function clearTimeoutInternal() {
                if (timeoutId) {
                    clearTimeout(timeoutId);
                    timeoutId = 0;
                }
            }
        });
    };
    WebSocketChannel.prototype.cookieHandshake = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var connId, cryptoKey, cookieHandshakeResponse, nConnectionToken;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        connId = uuid.v1();
                        cryptoKey = sjcl.random.randomWords(8, 6);
                        utils_1.setKeyExchangeCookie(connId, cryptoKey);
                        return [4, this.sendRequest({
                                AuthenticationOperation: 'Connect',
                                AuthenticationParameters: {
                                    connectionToken: null,
                                    browserName: aws_workdocs_web_client_common_1.BrowserService.getBrowser(),
                                    browserVersion: aws_workdocs_web_client_common_1.BrowserService.getBrowserVersion(),
                                    cookieDomain: window.location.hostname,
                                    cookieName: utils_1.KEY_EXCHANGE_COOKIE_NAME,
                                    connectionID: connId,
                                    cookieConfigurationJson: null,
                                },
                            })];
                    case 1:
                        cookieHandshakeResponse = _a.sent();
                        nConnectionToken = EncryptionService_1.decrypt(cookieHandshakeResponse.nConnectionToken, cryptoKey);
                        if (nConnectionToken === cookieHandshakeResponse.ConnectionToken) {
                            this.lastSucceededHandshakeMethod = 'COOKIE';
                            this.companionVersion = cookieHandshakeResponse.ApplicationVersion;
                            ConnectionPersistenceService_1.setConnectionInfo(this.companionConfig.userID, { connectionToken: cookieHandshakeResponse.ConnectionToken, cryptoKey: cryptoKey });
                        }
                        else {
                            throw new Error('[WEBSOCKET CHANNEL] Cookie handshake failed due to mismatch in nConnectionToken');
                        }
                        return [2];
                }
            });
        });
    };
    WebSocketChannel.prototype.quickHandshake = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var tokenInfo, cryptoKey, connectionToken, newCryptoKey, quickHandshakeResponse, nConnectionToken;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tokenInfo = ConnectionPersistenceService_1.getConnectionInfo(this.companionConfig.userID);
                        cryptoKey = tokenInfo.cryptoKey;
                        connectionToken = tokenInfo.connectionToken;
                        newCryptoKey = cryptoKey;
                        return [4, this.sendRequest({
                                AuthenticationOperation: 'Reconnect',
                                AuthenticationParameters: {
                                    connectionToken: connectionToken,
                                    nConnectionToken: EncryptionService_1.encrypt(connectionToken, cryptoKey),
                                    nNewEncryptionKey: EncryptionService_1.encrypt(sjcl.codec.base64.fromBits(newCryptoKey), cryptoKey),
                                },
                            })];
                    case 1:
                        quickHandshakeResponse = _a.sent();
                        nConnectionToken = EncryptionService_1.decrypt(quickHandshakeResponse.nConnectionToken, cryptoKey);
                        if (nConnectionToken === quickHandshakeResponse.ConnectionToken) {
                            this.lastSucceededHandshakeMethod = 'QUICK';
                            this.companionVersion = quickHandshakeResponse.ApplicationVersion;
                            ConnectionPersistenceService_1.setConnectionInfo(this.companionConfig.userID, { connectionToken: quickHandshakeResponse.ConnectionToken, cryptoKey: newCryptoKey });
                        }
                        else {
                            throw new Error('[WEBSOCKET CHANNEL] Quick handshake failed due to mismatch in nConnectionToken');
                        }
                        return [2];
                }
            });
        });
    };
    return WebSocketChannel;
}());
exports.WebSocketChannel = WebSocketChannel;
